import React from 'react'
import { Table } from 'antd'

const PageTable = ({
  pagination = {}, // 不指定时，默认分页；明确指定不分页是，不显示pagination
  ...props
}) => {
  return (
    <Table
      {...props}
      pagination={
        pagination
          ? {
              ...pagination,
              showSizeChanger: true,
              pageSizeOptions: ['10', '30', '50', '100'],
            }
          : false
      }
    />
  )
}

export default PageTable
